import { FC } from 'react';
import { UseFormRegister, UseFormSetValue, FieldErrors } from 'react-hook-form';
import { AdditionalOptionsTextBox } from 'components/hosted-scraping/edit-project-components/AdditionalOptionsTextBox';
import { CrawlerFormData } from 'pages/crawler/types';
import { validateCrawlerUrl } from 'pages/crawler/utils/crawlerValidation';
import CrawlerCostCalculator from 'pages/crawler/components/form/CrawlerCostCalculator';

interface CrawlerUrlInputProps {
  register: UseFormRegister<CrawlerFormData>;
  setValue: UseFormSetValue<CrawlerFormData>;
  errors: FieldErrors<CrawlerFormData>;
  watchedValues: CrawlerFormData;
  isLoading?: boolean;
}

/**
 * Shared URL input component for crawler forms
 */
export const CrawlerUrlInput: FC<CrawlerUrlInputProps> = ({
  register,
  setValue,
  errors,
  watchedValues,
  isLoading = false,
}) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        URL to Crawl <span className="text-red-500">*</span>
      </label>
      <AdditionalOptionsTextBox
        {...register('url', {
          required: 'URL is required',
          validate: validateCrawlerUrl,
        })}
        value={watchedValues.url}
        placeholder="https://httpbin.org/"
        callback={(value: string | undefined) =>
          setValue('url', value || '', { shouldValidate: true })
        }
      />
      {errors.url && (
        <p className="text-red-500 text-sm mt-1">{errors.url.message}</p>
      )}
      <CrawlerCostCalculator isLoading={isLoading} />
    </div>
  );
};
